// extracted by mini-css-extract-plugin
module.exports = {"container":"NotesCard_container__1vlxm","topic-container":"NotesCard_topic-container__2S-cH","notes":"NotesCard_notes__2etvK","last-updated":"NotesCard_last-updated__oXPw4"};